export default "__VITE_ASSET__COQAqdHr__"